import React from "react";

import { Link as RouterLink } from "react-router-dom";
import { Link as MaterialLink } from "@mui/material";

const InternalLink = ({ children, ...props }) =>
<MaterialLink component={RouterLink} {...props}>{children}</MaterialLink>

export default InternalLink